// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"0e8a2d7d","66":"d0968b5c","122":"9b9d4865","148":"94c70f02","243":"37466128","253":"664cfe96","343":"8bed2724","364":"482ad5e3","440":"7876e160","444":"4cd9dc87","459":"7964b811","625":"a6ce9410","665":"d9ee685c","748":"cce8e14a","937":"03496a57","967":"d71f95f2"}[chunkId] + ".chunk.js";
};